import type * as Highcharts from 'highcharts';
import { textLabels } from '../../constants';
import type { Distribution } from '../../types';

const LABELS: Record<string, string> = textLabels;

const PIE_BASE_OPTIONS: Highcharts.Options = {
  chart: { type: 'pie', height: '350' },
  title: { text: '', align: 'left' },
  legend: { enabled: true },
  credits: { enabled: false },
};

/** Breakdown of a distribution (CAPEX, OPEX, cleaning time), as absolute values; the empty chart without data. */
export const buildPieOptions = (
  data: Distribution | undefined,
  title: string,
  unit: string,
  width?: string | number,
): Highcharts.Options => {
  if (!data) return PIE_BASE_OPTIONS;
  return {
    ...PIE_BASE_OPTIONS,
    chart: { ...PIE_BASE_OPTIONS.chart, width },
    title: { ...PIE_BASE_OPTIONS.title, text: title },
    tooltip: { valueDecimals: 2, shared: true, valueSuffix: unit },
    series: [
      {
        type: 'pie',
        name: 'Amount',
        data: Object.keys(data.distribution).map((key) => ({ name: LABELS[key] || key, y: Math.abs(data.distribution[key]) })),
      },
    ],
  };
};
